import React from 'react';
import {
  Chip,
  Typography,
  Box,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const GWASAssociationTable = ({ gwasData }) => {
  const getSignificanceColor = (pval) => {
    if (!pval) return 'default';
    if (pval < 5e-8) return 'error';
    if (pval < 1e-6) return 'warning';
    if (pval < 0.05) return 'info';
    return 'default';
  };

  const formatPValue = (pval) => {
    if (pval === null || pval === undefined) return '';
    if (pval < 1e-10) return pval.toExponential(2);
    if (pval < 0.001) return pval.toExponential(2);
    return pval.toFixed(4);
  };

  if (!gwasData || gwasData.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          No GWAS data available for this gene.
        </Typography>
      </Box>
    );
  }

  const rows = gwasData.map((gwas, index) => ({
    id: index,
    disorder: gwas.disorder,
    z_stat: gwas.z_stat,
    pval: gwas.pval,
    rank: gwas.rank,
    n_samples: gwas.n_samples,
    n_snps: gwas.n_snps,
  }));

  const columns = [
    { field: 'disorder', headerName: 'Disorder', width: 220 },
    { field: 'z_stat', headerName: 'Z-score', width: 110, type: 'number',
      valueFormatter: (value) => value != null ? value.toFixed(3) : '' },
    { field: 'pval', headerName: 'P-value', width: 140, type: 'number',
      renderCell: (p) => p.value ? (
        <Chip label={formatPValue(p.value)} color={getSignificanceColor(p.value)} size="small" />
      ) : '' },
    { field: 'rank', headerName: 'Rank', width: 100, type: 'number',
      renderCell: (p) => (
        <Box>
          {p.value ? p.value.toLocaleString() : ''}
          {p.value === 1 && (
            <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>(best)</Typography>
          )}
        </Box>
      )},
    { field: 'n_samples', headerName: 'N Samples', width: 120, type: 'number',
      valueFormatter: (value) => value ? value.toLocaleString() : '' },
    { field: 'n_snps', headerName: 'N SNPs', width: 110, type: 'number',
      valueFormatter: (value) => value ? value.toLocaleString() : '' },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        autoHeight
      />
    </Box>
  );
};

export default GWASAssociationTable;
